import sessionStorageService, {
  SESSION_STORAGE_KEYS,
} from './sessionStorageService';
import uniqid from 'uniqid';

export default {
  get downloadUniqueId() {
    return this.ensureDownloadUniqueId();
  },

  set downloadUniqueId(uniqueId: string) {
    sessionStorageService.setItem(
      SESSION_STORAGE_KEYS.DOWNLOAD_UNIQUE_ID,
      uniqueId,
    );
  },

  removeDownloadUniqueId() {
    sessionStorageService.removeItem(SESSION_STORAGE_KEYS.DOWNLOAD_UNIQUE_ID);
  },

  generateDownloadUniqueId() {
    const uniqueId = uniqid();

    this.downloadUniqueId = uniqueId;

    return uniqueId;
  },

  ensureDownloadUniqueId(): string {
    const uniqueId = sessionStorageService.getItem<string>(
      SESSION_STORAGE_KEYS.DOWNLOAD_UNIQUE_ID,
    );

    return uniqueId || this.generateDownloadUniqueId();
  },
};
